var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "roundImageContainer" }, [
    _c(
      "a",
      {
        staticClass: "roundImage roundImageOrigin",
        style: { "background-image": "url(" + _vm.currentImage + ")" },
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            _vm.$bus.$emit("activateProfileAvatarEditor")
          }
        }
      },
      [_vm._m(0)]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "blackHover" }, [
      _c("i", { staticClass: "fa fa-camera" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f2a1fbd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2a1fbd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileAvatar.vue
// module id = 506
// module chunks = 2